import { baseRoutes } from "../../../helpers";

const accessRoute = {
  SUPERREPORTLIST: {
    path: `${baseRoutes.superBaseRoutes}/report-list`,
  },
};

export default accessRoute;

  